import { render, staticRenderFns } from "./addInstock.vue?vue&type=template&id=ce10ebd2&scoped=true&"
import script from "./addInstock.vue?vue&type=script&lang=js&"
export * from "./addInstock.vue?vue&type=script&lang=js&"
import style0 from "./addInstock.vue?vue&type=style&index=0&id=ce10ebd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10ebd2",
  null
  
)

export default component.exports